import { CommonModule } from '@angular/common';
import { Directive, EventEmitter, HostBinding, HostListener, NgModule, Output } from '@angular/core';



@Directive({
  selector: '[draganddrop]'
})
export class DraganddropDirective {

  @HostBinding('class.fileover') fileover:boolean;
  @Output() public filesDropped: EventEmitter<FileList>= new EventEmitter<FileList>();
  
  constructor() { }

  @HostListener('dragstart',['$event']) onDragStart(evt: any){
    evt.dataTransfer.effectAllowed = "move";
    evt.target.style.cursor='move';
  }
  @HostListener('dragend',['$event']) onDragEnd(evt: any){
    evt.dataTransfer.effectAllowed = "default";
    evt.target.style.cursor='default';
  }
  @HostListener('dragover',['$event']) onDragOver(evt: any){
    evt.preventDefault();
    evt.stopPropagation(); 
    evt.target.style.cursor='move';   
    this.fileover = true;
  }

  @HostListener('dragleave',['$event']) public onDragLeave(evt:any){
    evt.preventDefault();
    evt.stopPropagation(); 
    evt.target.style.cursor='default';       
  }
  @HostListener('drop',['$event']) public ondrop(evt: any){
    evt.preventDefault();
    evt.stopPropagation();
    evt.target.style.cursor='default';  
    this.fileover = false;
    const files : FileList = evt.dataTransfer.files;
    if (files.length>0)  this.filesDropped.emit(files);
  }

}
